
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';

@Component
export default class AutoPauseResume extends Vue {
  visible = false;

  moment = moment;

  @Prop()
  shopId!: string;

  @lazyInject(ShopService)
  shopService!: ShopService;

  modelStop = false;

  modelStart = false;

  form: any = {
    stopDate: null,
    startDate: '2025-01-25',
  };

  handleCancel() {
    this.modelStart = false;
    this.modelStop = false;
    this.visible = false;
  }

  init(data: any) {
    this.form = data;
    const { stopDate, startDate } = data;
    if (stopDate) {
      this.modelStop = true;
    } else {
      this.modelStop = false;
    }
    if (startDate) {
      this.modelStart = true;
    } else {
      this.modelStart = false;
    }
    this.visible = true;
  }

  async handleOk() {
    const params: any = {};
    if (this.modelStop) {
      params.stopDate = this.form.stopDate;
    }
    if (this.modelStart) {
      params.startDate = this.form.startDate;
    }
    const res = await this.shopService.postShopAutoclose(this.shopId, params);
    if (res) {
      this.$message.success('设置成功');
      this.visible = false;

      this.$emit('getShopDeta', this.shopId);
    }
    // console.log(res, 'res');
  }

  onChange() {}

  onChangeStop(date: Moment) {
    this.form.stopDate = moment(date).format('YYYY-MM-DD');
  }

  onChangeStart(date: Moment) {
    this.form.startDate = moment(date).format('YYYY-MM-DD');
  }

  public disabledDate(current: Moment) {
    return current < moment().add(0, 'd');
  }
}
